import $format from '../../utils/formatter'
const { drugAvailability } = require('@/api/siterequest')

export default {
  'entityName': 'siterequest_has_drug',
  'title': 'Drugs',
  id: ['siterequest_id', 'drug_id'],
  'pagination': {
    'rowsPerPage': 10,
    'page': 1,
    'sortBy': 'siterequest.id',
    'descending': true
  },
  'fields': [
    {
      value: 'drug_id',
      text: 'Drug',
      list: (_entity, search, item) => drugAvailability(item.protocol_id, item.country, search),
      type: 'autocomplete',
      title: 'name',
      subtitle: drug => $format('drug', drug, 'subtitle'),
      render: ({ drug }) => drug.packaging !== 'Labels' ? `${drug.name} (${drug.packaging}, ${drug.dose}${drug.measure_unit})` : `${drug.name} (${drug.packaging} - ${drug.labels?.join(',')}) `,
      table: true,
      validators: ['required']
    },
    {
      'value': 'multiplier',
      deps: ['drug_id'],
      default: (item, args, selected) => { 
        item.drug = selected
        return selected && selected.multiplier
      },
      type: 'hidden',
      visible: false
    },
    {
      value: '_n_box',
      text: 'N. box',
      deps: ['drug_id'],
      visible: (item) => !(item.drug && item.drug.packaging === 'Labels'),
      default: () => '',
      hint: item => {
        if (item.drug && item.drug.n_pieces > 1) {
          return `Each box includes ${item.drug.n_pieces} items`
        }
      },
      readonly: item => !item.drug_id,
      'validators': [
        'required',
        'number',
        (field, value, item) => item.multiplier === 0 || value%item.multiplier===0 || `${field.text} has to be a multiplier of ${item.multiplier}`
      ]
    },
    {
      value: '_n_sheet',
      text: 'N. sheet / paper',
      deps: ['drug_id'],
      default: () => '',
      visible: (item) => item.drug && item.drug.packaging === 'Labels',
      readonly: item => !item.drug_id,
      hint: item => {
        if (item.drug && item.drug.n_pieces > 1) {
          return `Each sheet includes ${item.drug.n_pieces} labels`
        }
      },
      'validators': [
        'required',
        'number',
        (field, value, item) => item.multiplier === 0 || value%item.multiplier===0 || `${field.text} has to be a multiplier of ${item.multiplier}`
      ]
    },    
    {
      'value': 'n_pieces',
      'text': 'N. box / sheet',
      deps: ['_n_box', '_n_sheet'],
      default: item => (item.drug && item.drug.packaging === 'Labels') ? item._n_sheet : item._n_box,
      'type': 'number',
      'table': {
        'sortable': true,
        'filter': false
      },
      visible: false
      // readonly: item => !item.drug_id,
    }
  ],
  actions: ['remove']
}
